/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocationProportionalServiceCategory extends models.BillingRuleAllocationGenericTargets {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocationProportionalServiceCategory");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocationProportionalServiceCategory.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocationProportionalServiceCategory>): BillingRuleAllocationProportionalServiceCategory {
        let obj = Object.assign(new BillingRuleAllocationProportionalServiceCategory(), model);
        BillingRuleAllocationProportionalServiceCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocationProportionalServiceCategory>): BillingRuleAllocationProportionalServiceCategory {
        if (!model) return null;
        return BillingRuleAllocationProportionalServiceCategory.newInstance(<BillingRuleAllocationProportionalServiceCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocationProportionalServiceCategory) {
        if (!obj) return;

        models.BillingRuleAllocationProportionalServiceCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocationProportionalServiceCategory): boolean {
        if (models.BillingRuleAllocationGenericTargets.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocationProportionalServiceCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of service categories to allocate by
     */
    service_categories: Array<string>;

}
